'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (text, entities) {
  (0, _convertUnicodeIndices2.default)(text, entities, false);
};

var _convertUnicodeIndices = require('./lib/convertUnicodeIndices');

var _convertUnicodeIndices2 = _interopRequireDefault(_convertUnicodeIndices);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

module.exports = exports['default'];